import React, { useState } from "react";
import { App, message, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  addDefaultSupporter,
  clearSupporterInfo,
  deleteDefaultSupporter,
  searchEmail,
  setDefaultSupporterOpenAdd,
  setDefaultSupporterOpenEdit,
  setDefaultSupporterSelected,
  setSearchById,
  updateDefaultSupporter,
} from "store/user/(default)/supporter/default_supporter.action";
import {
  defaultSupporterAllSelector,
  defaultSupporterInfoSelector,
  defaultSupporterSearchSelector,
  defaultSupporterSelectedSelector,
} from "store/user/(default)/supporter/default_supporter.selector";

//
//component
//redux
//selector

//actions

//utils
//hook
//str

const { confirm } = Modal;

// ========= search user detail ================//
export const useSupporterSearch = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleSearchByEmail = ({ email }) => {
    setLoading(true);
    dispatch(
      searchEmail({ email }, (res) => {
        setLoading(false);
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const handleSearchById = ({ id }) => {
    console.log({ id });
    setLoading(true);
    dispatch(
      setSearchById({ id }, (res) => {
        setLoading(false);
        console.log({ id, res });
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const handleRemoveSupporter = () => {
    dispatch(clearSupporterInfo());
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleSearchByEmail,
    handleRemoveSupporter,
    handleSearchById,
  };
};

export const useSupporterAdd = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const supporterInfo = useSelector(defaultSupporterInfoSelector);
  // -------------------------- FUNCTION ------------------------
  const handleOpenAdd = () => {
    dispatch(setDefaultSupporterOpenAdd(true));
  };

  const handleCloseAdd = (form) => {
    dispatch(setDefaultSupporterOpenAdd(false));
    dispatch(clearSupporterInfo());
    form?.resetFields();
  };

  const handleAdd = (form) => {
    form
      .validateFields()
      .then((values) => {
        if (values && supporterInfo) {
          const id = supporterInfo?.uid;
          const { supporters, note } = values;
          setLoading(true);
          dispatch(
            addDefaultSupporter({ id, note, supporters }, (response) => {
              setLoading(false);
              if (response.status === 200) {
                message.success("Thêm nhân viên thành công");
                handleCloseAdd(form);
              } else if (response.status === 500) {
                message.error(response.data);
              }
            }),
          );
        }
      })
      .catch((err) => {
        message.error(err?.message || "Vui lòng thử lại lần sau");
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpenAdd, handleCloseAdd, handleAdd };
};

//edit
export const useSupporterEdit = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const selected = useSelector(defaultSupporterSelectedSelector);
  // -------------------------- FUNCTION ------------------------
  const handleOpenEdit = (data) => {
    dispatch(setDefaultSupporterSelected(data));
    dispatch(setDefaultSupporterOpenEdit(true));
  };

  const handleCloseEdit = (form) => {
    dispatch(setDefaultSupporterOpenEdit(false));
    form?.resetFields();
  };

  const handleEdit = (form) => {
    form
      .validateFields()
      .then((values) => {
        if (values && selected) {
          setLoading(true);
          const id = selected?.id;
          const supporters = values?.supporters || [];
          dispatch(
            updateDefaultSupporter({ id, supporters }, (response) => {
              setLoading(false);
              if (response.status === 200) {
                message.success("Cập nhật nhân viên thành công");
                handleCloseEdit(form);
              } else if (response.status === 500) {
                message.error(response.data);
              }
            }),
          );
        }
      })
      .catch((err) => {
        message.error(err?.message || "Vui lòng thử lại lần sau");
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleOpenEdit, handleCloseEdit, handleEdit };
};

//delete
export const useSupporterRemove = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------

  const showConfirmDelete = (data) => {
    console.log({ data, message: "CONFIRM!" });
    confirm({
      title: "Bạn có muốn xoá nhân viên này không?",
      icon: <ExclamationCircleFilled />,
      onOk() {
        handleDelete(data);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleDelete = (data) => {
    const id = data?.id;
    console.log({ id });
    setLoading(true);
    dispatch(
      deleteDefaultSupporter({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Xoá nhân viên thành công");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    showConfirmDelete,
  };
};

// =========search & filter ================//
export const useSupporterRefine = () => {
  // -------------------------- VAR -----------------------------
  const fields = ["fullName", "email"];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultSupporterAllSelector);
  const search = useSelector(defaultSupporterSearchSelector);

  // -------------------------- FUNCTION ------------------------
  const refined = refineData(data, search, fields);

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return refined;
};

const refineData = (data, search, fields) => {
  let final = data || [];

  if (search !== "") {
    final = final?.filter((d) => {
      const string = combineValueSearch(fields, d);
      console.log({ string });
      const lowerName = string?.toLowerCase();
      const lowerSearch = search?.toLowerCase();
      const valids = lowerName?.includes(lowerSearch) || false;
      return valids;
    });
  }

  return final;
};

const combineValueSearch = (fields, d) => {
  let finalStr = "";

  fields?.forEach((field) => {
    const value = d[field] || null;
    if (value) {
      finalStr += `@${value}`;
    }
  });

  return finalStr;
};
